// extracted by mini-css-extract-plugin
export default {"add-tag-form":"TagView_add-tag-form__IZ04r","add-tag-button":"TagView_add-tag-button__v4Yz-","add-tag-input":"TagView_add-tag-input__l28Cd"};